<template>
    <div v-if="!isLoading" :id="id" class="m-b-20 m-t-20 fund-card" :style="{background: backgroundColor || '#b9ede8'}">
      <div class="fund-header is-flex is-justify-content-space-between is-align-items-center m-b-20">
        <div class="has-text-weight-bold fund-title"> {{ title }}
          <div class="text-grey has-text-weight-medium" style="font-size: 14px;line-height: 1" v-if="subTitle">{{ subTitle }}</div>
        </div>
        <div>
          <b-field>
            <b-select @change.native="sortList(selected.value, keyword, worst)" class="w-100"  v-model="selected">
                <option  v-for="(i) in options" :value="i" :key="i.value">{{ i.text }}</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <div v-for="(i, index) in list.slice(0, limit || Limit)" :key="index" class="m-b-10 is-flex is-justify-content-space-between wrapper-text">
        <span class="is-flex wrapper-fund"><span style="color:#000">{{ index + 1 }}</span>&nbsp;<span class="link has-text-underline" v-on:click="buttonClickHandler(i, type)">{{ i.name }}</span></span>
        <span v-if="i.value < 0" class='color-red'>{{parseFloat(i.value).toFixed(1)}}%</span>
        <span v-else-if="i.value == 0">{{parseFloat(i.value).toFixed(1)}}%</span>
        <span v-else>+{{parseFloat(i.value).toFixed(1)}}%</span>
      </div>
    </div>
    <div class="preloader-center" v-else>
            <Preloader />
    </div>
</template>
<style scoped>
.fund-card {
  border: 1px solid #4f81bd;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 0px 2px 4px #4f81bd;
}
.fund-header  {
  gap: 0.2rem;
}
.fund-title {
  text-transform: capitalize;
  gap: 5px;
  display: flex;
  flex-direction: column;
}
.link {
  color:#009BDE;
  cursor: pointer;
}
.link:hover {
  color:#333333;
}
.wrapper-text {
  font-size: 0.85em;
  gap: 1rem;
}
.wrapper-fund {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
}
::v-deep .select select:not([multiple]) {
  padding-right: 2em;
}
::v-deep .select:not(.is-multiple):not(.is-loading)::after{
  right: 0.75em;
}
</style>
<script>
import Preloader from "@/components/Preloader";

export default {
    name: 'TopList',
    components: {Preloader},
    props: {
      list: [],
      title: String,
      subTitle: String,
      limit: Number,
      type: String,
      keyword: String,
      backgroundColor: String,
      worst: Boolean,
      id: String,
    },
    data: function () {
        return {
            Limit: 5,
            isLoading: false,
            selected: { value: 'ytd', text: 'NTR YTD' },
            options: [
              { value: 'ytd', text: 'NTR YTD' },
              { value: '1y', text: 'NTR 1Y' },
              { value: '3y', text: 'NTR 3Y' },
              { value: '5y', text: 'NTR 5Y' },
            ]
        }
    },
    mounted(){
    },
    updated() {
    },
    watch: {
    },
    methods: {
      sortList(selected ,keyword, worst){
        this.$emit('sortList', selected ,keyword, worst)
      },
      buttonClickHandler(i, type) {
        i.type = type;
        i.sortBy = this.selected.value;
        this.$emit('goToLink', i)
      },
    },
    created() {
    },
    beforeDestroy() {
    }

}
</script>
